import { DndContext, DragEndEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import StageColumn, { BoardStage } from './StageColumn';
import { Broker } from './OpportunityCard';

export default function OpportunityBoard({ stages, brokers, onCardClick, onMove, sortKey, personaFilter }: {
  stages: BoardStage[]; brokers: Record<string, Broker>; onCardClick: (id: string) => void;
  onMove: (oppId: string, toStageId: string) => void;
  sortKey: 'value' | 'age' | 'updated';
  personaFilter: string | null;
}) {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));
  const handleEnd = (e: DragEndEvent) => {
    const oppId = String(e.active.id); const toStageId = e.over ? String(e.over.id) : '';
    if (!toStageId) return;
    const from = stages.find((s) => s.opportunities.some((o) => o.id === oppId));
    if (from && from.id !== toStageId) onMove(oppId, toStageId);
  };
  return (
    <DndContext sensors={sensors} onDragEnd={handleEnd}>
      <div className="flex gap-3 overflow-x-auto pb-3">
        {stages.map((s) => (
          <StageColumn
            key={s.id}
            stage={s}
            brokers={brokers}
            onCardClick={onCardClick}
            sortKey={sortKey}
            personaFilter={personaFilter}
          />
        ))}
      </div>
    </DndContext>
  );
}
